export function AlignBottomVerticalIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3a1 1 0 011 1v9h2.575a.5.5 0 01.312.89l-3.575 2.86a.5.5 0 01-.624 0l-3.575-2.86a.5.5 0 01.312-.89H11V4a1 1 0 011-1zM3 20a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
